import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared';
import { DialogConfirmActionComponent } from './dialogs/dialog-confirm-action/dialog-confirm-action.component';
import { DialogConfirmCloseComponent } from './dialogs/dialog-confirm-close/dialog-confirm-close.component';
import { DialogSelectDepartmentComponent } from './dialogs/dialog-select-department/dialog-select-department.component';
import { CommonDialogsService } from './services/common-dialogs/common-dialogs.service';

@NgModule({
  declarations: [DialogConfirmCloseComponent, DialogSelectDepartmentComponent, DialogConfirmActionComponent],
  providers: [CommonDialogsService],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
})
export class CommonDialogsModule {}
